<template>
  <div justify="center">
    <v-dialog v-model="planDialog" persistent class="main-dialog"  :max-width="mainDialogWidth">
      <v-card justify="center">
        <!-- ダイアログタイトル -->
        <v-card-title class="subtitle-1 light-green lighten-3">ご希望のプランを選択してください。</v-card-title>

        <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>

        <!-- 基本プラン(プラン種別 = '0') -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="12" md="11" lg="10" xl="10">
            <v-expansion-panels :tile="true" v-model="openBasePanelIndx">
              <v-expansion-panel>
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="panel-title" color="grey lighten-2">
                  <label>基本プラン</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row v-for="dispPlan in dispPlanList" v-bind:key="dispPlan.planCd" >
                    <!-- <template  v-if="dispPlan.planTyp == '1'">
                      <v-col cols="2" sm="3" class="d-flex align-center justify-end" >
                          <v-checkbox v-model="dispPlan.isSelected">
                            <template v-slot:label>
                              <v-avatar class="mr-5 plan-img" size="80" tile>
                                <v-img :src="dispPlan.img"></v-img>
                              </v-avatar>
                            </template>
                          </v-checkbox>
                      </v-col>
                      <v-col cols="10" sm="9" class="mt-3">
                          <v-row dense>
                            <v-col cols="12">
                              {{ dispPlan.planCd }}
                            </v-col>
                          </v-row>
                         <v-row dense>
                            <v-col cols="12" class="text-decoration-underline">
                              <p class="title-text-h mb-1">{{ dispPlan.name }}</p>
                            </v-col>
                          </v-row>
                         <v-row dense class="mb-3">
                            <v-col cols="12">
                              <p v-html="dispPlan.description"></p>
                            </v-col>
                          </v-row>
                      </v-col>
                    </template> -->
                    <template  v-if="dispPlan.planTyp == '1' && !dispPlan.autoAddFlg">
                      <v-col cols="2" sm="3" class="d-flex align-center justify-end" >
                          <v-checkbox v-model="dispPlan.isSelected" @change="changePlanCheckBox(dispPlan.planCd)">
                            <template v-slot:label>
                              <v-avatar class="mr-5 plan-img" size="80" tile>
                                <v-img :src="dispPlan.imageUrl"></v-img>
                              </v-avatar>
                            </template>
                          </v-checkbox>
                      </v-col>
                      <v-col cols="10" sm="9" class="mt-3">
                        <template v-if="!dispPlan.childPlanUmuFlg">
                          <v-row dense>
                            <v-col cols="12">
                              {{ dispPlan.planCd }}
                            </v-col>
                          </v-row>
                         <v-row dense>
                            <v-col cols="12" class="text-decoration-underline">
                              <p class="title-text-h mb-1">{{ dispPlan.name }}</p>
                            </v-col>
                          </v-row>
                         <v-row dense class="mb-3">
                            <v-col cols="12">
                              <p v-html="dispPlan.description"></p>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else>
                           <v-row dense>
                          </v-row>
                         <v-row dense>
                            <v-col cols="12" class="text-decoration-underline">
                              <p class="title-text-h mb-1">{{ dispPlan.nameDetail1 }}</p>
                            </v-col>
                          </v-row>
                         <v-row dense class="mb-0">
                            <v-col cols="12" class="mt-0 pt-0">
                              <p v-html="dispPlan.description" class="mb-0"></p>
                            </v-col>
                          </v-row>
                          <v-row dense class="mt-0" >
                            <v-col cols="12" class="py-0">
                              <v-radio-group v-model="dispPlan.selectedChildPlanCd" row>
                                <v-radio v-for="dispChildPlan in dispPlan.childPlanSelectDtoList"
                                  color="indigo"
                                  :key="dispChildPlan.planCd"
                                  :label="dispChildPlan.nameDetail2"
                                  :value="dispChildPlan.planCd"
                                  :disabled="!dispPlan.isSelected"
                                >
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </template>
                      </v-col>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <!-- オプションプラン(プラン種別 = '1') -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="12" md="11" lg="10" xl="10">
            <v-expansion-panels :tile="true" v-model="openOptionPanelIndx">
              <v-expansion-panel>
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="panel-title" color="grey lighten-2">
                  <label>オプションプラン</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row v-for="dispPlan in dispPlanList" v-bind:key="dispPlan.planCd" dense>
                    <template  v-if="dispPlan.planTyp == '2' && !dispPlan.isAutoAdd">
                      <v-col cols="2" sm="3" class="d-flex align-center justify-end" >
                          <v-checkbox v-model="dispPlan.isSelected">
                            <template v-slot:label>
                              <v-avatar class="mr-5 plan-img" size="80" tile>
                                <v-img :src="dispPlan.imageUrl"></v-img>
                              </v-avatar>
                            </template>
                          </v-checkbox>
                      </v-col>
                      <v-col cols="10" sm="9" class="mt-3">
                          <v-row dense>
                            <v-col cols="12">
                              {{ dispPlan.planCd }}
                            </v-col>
                          </v-row>
                         <v-row dense>
                            <v-col cols="12" class="text-decoration-underline">
                              <p class="title-text-h mb-1">{{ dispPlan.name }}</p>
                            </v-col>
                          </v-row>
                         <v-row dense class="mb-3">
                            <v-col cols="12">
                              <p v-html="dispPlan.description"></p>
                            </v-col>
                          </v-row>
                      </v-col>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>
        <!-- ボタン -->
        <v-row justify="center" align-content="start">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="confirm()">確定</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
              <v-btn x-large color="warning" dark min-width="200px" @click="cancel()">キャンセル</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>
        </v-card-text>
      </v-card>  
    </v-dialog>
    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
  </div>
</template>

<script>
// import constants from '../common/constants';
import Utils from "../common/utils";

export default {
  name: "SelectPlanDialog",
  props: ["isOpen", "doYes", "doNo", "isClear"],
  data() {
    return {
      screenTitle: "プラン選択",
      planDialog: false,
      planDialogClear: false,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dispPlanList: [],
      openBasePanelIndx: 0,
      openOptionPanelIndx: 0,
      selectdBasePlanIds: [],
      selectdOptionPlanIds: [],
      updated: false,
    };
  },
  watch: {
    isOpen: function (val) {
      this.planDialog = val;
      this.initialize();
      this.moveTop();
    },
    isClear: function(val) {
      this.planDialogClear = val;
      if (!this.planDialogClear) {
        return;
      }
      this.$store.dispatch("requestRegInfo/setSelectedPlanIdList", []);
      this.initialize();
      this.planDialogClear = false;
    },
  },
  computed: {
    mainDialogWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' || bp == 'sm' || bp == 'md') {
        return "100%";
      } else if (bp == 'lg' || bp == 'xl') {
        return "46%";
      } else {
        return "60%";
      }
    },
  },
  created() {
    // this.initialize();
  },
  updated() {

  },
  
  methods: {
    moveTop: function() {
      const elements = document.getElementsByClassName('v-dialog--active');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },
    /*
    * 初期表示
    */
    // initialize() {

    //   // プランマスタ取得
    //   let planArry = this.$store.getters["master/getPlanMstList"];
    //   if (Utils.isNullOrEmptyOrUunDef(planArry)) {
    //     return ;
    //   }
    //   // 選択済みプランIDリスト
    //   let selectedPlanArry =  this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
    //   if (Utils.isNullOrEmptyOrUunDef(selectedPlanArry)) {
    //     selectedPlanArry = new Array();
    //   }
    //   // 表示用プラン情報設定
    //   let dispPlanBuffList = [];
    //   let dispPlanBuff = {};
    //   let isSelected = false;
    //   planArry.forEach(function(plan) {
    //     // 選択済みプランCD有無(isSelected)セット
    //     isSelected = false;
    //     if (selectedPlanArry.indexOf(plan.planCd) > -1) {
    //       isSelected = true;
    //     }
    //     dispPlanBuff = { 'planCd': plan.planCd, "displayPlanCd": plan.displayPlanCd, 'planTyp': plan.planTyp, 'name': plan.name, 'nameDetail1': plan.nameDetail1, 'nameDetail2': plan.nameDetail2, 'description': plan.description, 'img': plan.imageUrl, "price": plan.price, "autoAddFlg": plan.autoAddFlg, 'supplInfo1': plan.supplInfo1, 'supplInfo2': plan.supplInfo2, 'supplInfo3': plan.supplInfo3, "selectTyp": plan.selectTyp,'isSelected': isSelected, 'categoryCd': plan.categoryCd, 'regDetailTyp': plan.regDetailTyp };
    //     dispPlanBuffList.push(dispPlanBuff);
    //   });
    //   if (dispPlanBuffList.length > 0) {
    //     this.dispPlanList = dispPlanBuffList;
    //   }
    // },
    initialize: function() {

      // プランマスタ取得
      let planArry = this.$store.getters["master/getDisplayPlanList"];
      if (Utils.isNullOrEmptyOrUunDef(planArry)) {
        return ;
      }
      // 選択済みプランIDリスト
      let selectedPlanArry =  this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
      if (Utils.isNullOrEmptyOrUunDef(selectedPlanArry)) {
        selectedPlanArry = new Array();
      }
      // 表示用プラン情報設定
      let dispPlanBuffList = [];
      let dispPlanBuff = {};
      let isSelected = false;
      let selectedChildPlanCd = "";
      planArry.forEach(function(plan) {
        // 選択済みプランCD有無(isSelected)セット
        isSelected = false;
        if (!plan.childPlanUmuFlg) {
          if (selectedPlanArry.indexOf(plan.planCd) > -1) {
            isSelected = true;
          }
        } else {
          let childPlanArry = plan.childPlanSelectDtoList;
          childPlanArry.forEach(function(childPlan) {
            if (selectedPlanArry.indexOf(childPlan.planCd) > -1) {
              isSelected = true;
              selectedChildPlanCd = childPlan.planCd
            }
          });
        }
        dispPlanBuff = { 'childPlanUmuFlg': plan.childPlanUmuFlg, 'selectedChildPlanCd': selectedChildPlanCd, 'childPlanSelectDtoList': plan.childPlanSelectDtoList, 'isSelected': isSelected, 'categoryCd': plan.categoryCd, 'selectTyp': plan.selectTyp, 'planCd': plan.planCd, 'displayPlanCd': plan.displayPlanCd, 'planTyp': plan.planTyp, 'regDetailTyp': plan.regDetailTyp, 'name': plan.name, 'nameDetail1': plan.nameDetail1, 'nameDetail2': plan.nameDetail2, 'description': plan.description, 'price': plan.price, 'autoAddFlg': plan.autoAddFlg, 'imageUrl': plan.imageUrl, 'supplInfo1': plan.supplInfo1, 'supplInfo2': plan.supplInfo2, 'supplInfo3': plan.supplInfo3 };
        dispPlanBuffList.push(dispPlanBuff);
      });
      if (dispPlanBuffList.length > 0) {
        this.dispPlanList = dispPlanBuffList;
      }
    },
    changePlanCheckBox: function(planCd) {
      if (Utils.isNullOrEmptyOrUunDef(planCd)) {
        return;
      }
      this.dispPlanList.forEach(function(dispPlan) {
        if (dispPlan.childPlanUmuFlg && dispPlan.isSelected == '0') { 
          dispPlan.selectedChildPlanCd = null;
        }
      });
    },
    /**
     * 「確定」ボタン押下
     */
    confirm: function() {
      
      // 入力チェック
      let errMsg = this.checkInpuValue();
      if (errMsg != "") {
        this.dlgMsg.msg = errMsg;
        this.dlgMsg.isOpen = true;
        return;
      }

      let selectedCds = [];
      for (let dispPlan of this.dispPlanList) {
        if (dispPlan.isSelected) {
          // sectedFlg = true;
          if (dispPlan.childPlanUmuFlg) {
            selectedCds.push(dispPlan.selectedChildPlanCd);
          } else {
            selectedCds.push(dispPlan.planCd);
          }
        } else {
          if (dispPlan.autoAddFlg) {
            selectedCds.push(dispPlan.planCd);
          }
        }
      }
        // if ((dispPlan.isSelected && dispPlan.selectTyp == "1") || (dispPlan.isSelected && dispPlan.selectTyp == "")) {
        //   selectTypCnt += 1;
        // }
      
      // if (!sectedFlg) {
      //   this.dlgMsg.msg = this.$i18n.t('msg.err.cm010', ['お申込みプラン']);
      //   this.dlgMsg.isOpen = true;
      //   return;
      // }
      // if (selectTypCnt >= 2) {
      //   this.dlgMsg.msg = this.$i18n.t('msg.err.mb012');
      //   this.dlgMsg.isOpen = true;
      //   return;
      // }
      // 選択プランIDリスト(ストア)設定
      this.$store.dispatch('requestRegInfo/setSelectedPlanIdList', selectedCds);
      // プラン選択閉じる
      this.doYes();
      this.planDialog = false;
    },
    /**
     * 「キャンセル」ボタン押下
     */
    cancel: function() {
      // 初期化
      this.initialize()
      // プラン選択閉じる
      this.doNo();
      this.planDialog = false;
    },
    checkInpuValue: function() {
      let reVal = "";
      // 基本プラン必須選択
      let baseSectedFlg = false;
      for (let dispPlan of this.dispPlanList) {
        if (!dispPlan.isSelected) {
          continue;
        }
        if (dispPlan.planTyp == '1' && (dispPlan.regDetailTyp == '02' || dispPlan.regDetailTyp == '04')) {
          baseSectedFlg = true;
          break;
        }
      }
      if (!baseSectedFlg) {
        reVal = this.$i18n.t('msg.err.cm010', ['お申込みプラン']);
        return reVal;
      }
      // プラン必須選択(ラジオ)
      let radioSectedFlg = false;
      for (let dispPlan of this.dispPlanList) {
        if (!dispPlan.isSelected) {
          continue;
        }
        if (!dispPlan.childPlanUmuFlg) {
          continue;
        }
        if (dispPlan.selectedChildPlanCd !== null && dispPlan.selectedChildPlanCd != "") {
          radioSectedFlg = true;
          break;
        }
      }
      if (!radioSectedFlg) {
        reVal = this.$i18n.t('msg.err.cm010', ['資本金']);
        return reVal;
      }
      
      // 併用選択不可
      let categoryCd = "";
      let categoryPlanCount = 0;
      let selectTyp = "";
      let hasErrData = false;
      for (let dispPlan of this.dispPlanList) {
        if (!dispPlan.isSelected) {
          continue;
        }
        if (dispPlan.categoryCd != categoryCd) {
          if (categoryCd != "" && selectTyp == "1" && categoryPlanCount > 1) {
            // エラー
            hasErrData = true;
            break;
          }
          categoryPlanCount = 0;
          categoryCd = dispPlan.categoryCd;
          selectTyp = dispPlan.selectTyp;
        }
        categoryPlanCount += 1;
      }
      if (!hasErrData && selectTyp == "1" && categoryPlanCount > 1) {
        hasErrData = true;
      }
      if (hasErrData) {
        reVal = this.$i18n.t('msg.err.mb012');
        return reVal;
      }
      return reVal;
    },

  },
};
</script>

<style scoped>
/* カードタイトル(プラン名) */
.title-text-h {
  font-size: 1.525rem !important;
  font-weight: 400;
  line-height: 2.0rem;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif !important;
}
.main-dialog {
  max-width: 90%;
}
.plan-img {
  display: inline;
}
@media screen and (max-width: 750px) {

  /* カードタイトル(プラン名) */
  .title-text-h {
    font-size: 1.0rem !important;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif !important;
  }
  .plan-img {
    display: none;
    
  }
}

</style>
